module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/regular/arrow-circle-down-80972e666eec74cc068b019fe67f7fc5.svg";